import { render, staticRenderFns } from "./ImgPrint.vue?vue&type=template&id=7b6b22a4&scoped=true"
import script from "./ImgPrint.vue?vue&type=script&lang=js"
export * from "./ImgPrint.vue?vue&type=script&lang=js"
import style0 from "./ImgPrint.vue?vue&type=style&index=0&id=7b6b22a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b22a4",
  null
  
)

export default component.exports